module.exports = __webpack_public_path__ + "static/media/exam-result.47ede432.jpg";